import React, { useState, useEffect, useCallback } from "react";
import profile from "../../Assets/Images/undraw_profile.svg";
import camera from "../../Assets/Images/camera-icon.png";
import axiosHttp from "../../Config";
import Loader from "../../Components/Loader";
import { toast } from "react-toastify";
import { validateFile } from "../../Utils/Application-helper";
import axios from "axios";
import { BASE_URL } from "../../Utils/Url";
import { useAuth } from "../../authContext";

const AppSettings = () => {
  const [formValues, setFormValues] = useState({
    name: "",
    emailId: "",
    password: "",
    url: "",
  });
  const [error, setError] = useState({
    name: "",
    emailId: "",
    password: "",
    url: "",
  });
  const [loading, setLoading] = useState(true);
  const [loadedImage, setLoadedImage] = useState();
  const { setUserName, setProfileImg } = useAuth();

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  const fetchProfile = useCallback(async () => {
    try {
      const getProfileData = await axiosHttp.get("profile");
      if (getProfileData.status === 200) {
        const data = getProfileData.data.data;
        setFormValues((prev) => ({
          ...prev,
          name: data?.userName,
          emailId: data?.email,
          url: data?.picUrl,
        }));
        localStorage.setItem("userName", data?.userName);
        localStorage.setItem("profileImg", data?.picUrl);
        setUserName(data?.userName);
        setProfileImg(data?.picUrl);
        setLoadedImage(data?.picUrl);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  }, [setProfileImg, setUserName]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setError({ ...error, [name]: "" });
    setFormValues({ ...formValues, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const validationRes = validateFile(file, "image");
    if (validationRes.errors.length) {
      toast.error(validationRes.errors[0]);
      return;
    }
    setFormValues({ ...formValues, url: file });
    setLoadedImage(URL.createObjectURL(file));
  };

  const handleSubmit = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (formValues.name === "") {
      setError({ ...error, name: "Username required" });
    } else if (formValues.emailId === "") {
      setError({ ...error, emailId: "Email required" });
    } else if (!emailRegex.test(formValues.emailId)) {
      setError({ ...error, emailId: "Enter a valid email" });
    } else if (
      formValues.password !== "" &&
      formValues.password.trim().length < 4
    ) {
      setError({ ...error, password: "Enter minimum 4 characters" });
    } else {
      profileImageHandler();
    }
  };

  const profileImageHandler = async () => {
    setLoading(true);
    const formData = new FormData();
    let { url } = formValues;

    formData.append("image", url);
    try {
      const updateProfileImg = await axios.post(
        `${BASE_URL}/upload-image`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (updateProfileImg.status === 200) {
        let data = updateProfileImg.data.tempPath;
        setFormValues({ ...formValues, url: data });
        let submitPayload = { ...formValues, url: data };
        submitHandler(submitPayload);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const submitHandler = async (submitPayload) => {
    const payload = {};
    for (const key in submitPayload) {
      if (key === "password" && submitPayload[key]) {
        payload[key] = btoa(submitPayload[key]);
      } else if (submitPayload[key]) {
        payload[key] = submitPayload[key];
      }
    }
    try {
      const submitProfileData = await axiosHttp.post(`admin-profile`, payload);
      if (submitProfileData.status === 201) {
        localStorage.removeItem("userName");
        localStorage.removeItem("profileImg");
        fetchProfile();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="container-fluid top-container">
      <div className=" post mb-5">
        <div className="card  card-one-1 h-100">
          <div className="card-body">
            <h4 className="title mb-4">Settings</h4>
            <div className="row mb-3">
              <div className="col-md-6">
                <h5 className="head">Profile</h5>
              </div>
              <div className="col-md-6 text-right"></div>
            </div>
            <div className="row">
              <div className="col-md-4"></div>
              <div className="col-md-4">
                <img
                  className="img-set rounded-circle admin-img"
                  src={loadedImage || profile}
                  alt="profile"
                />
                <span>
                  <label className="camera-icon" htmlFor="fileInput">
                    <img
                      src={camera}
                      className="img-fluid  cursor-pointer"
                      alt="camera"
                    />
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    hidden
                  />
                </span>
              </div>
              <div className="col-md-4"></div>
            </div>

            <div className="row mt-5">
              <div className="col-md-4">
                <div className="form-group input-group mb-5">
                  <label className="has-float-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={formValues.name}
                      name="name"
                      onChange={handleChange}
                    />
                    <span>Name</span>
                    {error.name && <p className="form-error">{error.name}</p>}
                  </label>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group input-group mb-5">
                  <label className="has-float-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={formValues.emailId}
                      name="emailId"
                      onChange={handleChange}
                    />
                    <span>Email</span>
                    {error.emailId && (
                      <p className="form-error">{error.emailId}</p>
                    )}
                  </label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group input-group mb-5">
                  <label className="has-float-label">
                    <input
                      className="form-control"
                      type="password"
                      value=""
                      name="password"
                      onChange={handleChange}
                    />
                    <span>Password</span>
                    {error.password && (
                      <p className="form-error">{error.password}</p>
                    )}
                  </label>
                </div>
              </div>
            </div>

            <div className="row m-auto w-100">
              <button
                className="btn btn-primary modal-btn d-block m-auto"
                onClick={handleSubmit}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppSettings;

